import axios from '../utils/axios'

// 免单卡页面
export function FreeCardIndex (params) {
  return axios({
    url: '/SaleV2/FreeCard/Index',
    method: 'get',
    params: params
  })
}

// 领取免单卡
export function BuyerFreeCardGain (data) {
  return axios({
    url: '/SaleV2/FreeCard/BuyerFreeCardGain',
    method: 'post',
    data: data
  })
}

// 关注公众号活动免单卡领取
export function WyflSubscribeFreeCardGain (data) {
  return axios({
    url: '/SaleV2/FreeCard/WyflSubscribeFreeCardGain',
    method: 'post',
    data: data
  })
}

// 免单卡详情
export function GetFreeCardLog (params) {
  return axios({
    url: '/SaleV2/FreeCard/GetFreeCardLog',
    method: 'get',
    params: params
  })
}

// 免单规则数据
export function GiveFriendInfo (query) {
  return axios({
    url: '/SaleV2/FreeCard/GiveFriendInfo',
    method: 'GET',
    params: query
  })
}

// 查看更多参与者
export function FriendUrlList (query) {
  return axios({
    url: '/SaleV2/FreeCard/FriendUrlList',
    method: 'GET',
    params: query
  })
}

// 兑换商品
export function CheckExChange (data) {
  return axios({
    url: '/SaleV2/FreeCard/CheckExChange',
    method: 'POST',
    data: data
  })
}

// 每周福利领取信息
export function GetWeekWelfareInfo (params) {
  return axios({
    url: '/SaleV2/FreeCard/GetWeekWelfareInfo',
    method: 'GET',
    params: params
  })
}

// 未来节点商品抢购
export function ZeroYuanFutureNodeBuyingPage (data = {}) {
  return axios({
    url: '/Sale/Sale/ZeroYuanFutureNodeBuyingPage',
    method: 'post',
    data: data
  })
}
export function ZeroYuanFutureNodeBuyingNoLogin (data = {}) {
  return axios({
    url: '/NoAuth/SaleIndex/ZeroYuanFutureNodeBuyingNoLogin',
    method: 'post',
    data: data
  })
}

// 抢购中节点商品获取
export function GetBannerRushBuyList (data = {}) {
  return axios({
    url: '/Sale/Sale/GetBannerRushBuyList',
    method: 'post',
    data: data
  })
}
export function GetBannerRushBuyListNoLogin (data) {
  return axios({
    url: '/NoAuth/SaleIndex/GetBannerRushBuyListNoLogin',
    method: 'post',
    data: data
  })
}

// 限时抢购商品获取
export function GetRushBuyList (data) {
  return axios({
    url: '/Sale/Sale/GetRushBuyList',
    method: 'post',
    data: data
  })
}
export function GetRushBuyListNoLogin (data) {
  return axios({
    url: '/NoAuth/SaleIndex/GetRushBuyListNoLogin',
    method: 'post',
    data: data
  })
}
